import NextImage from 'next/image'
import Link from 'next/link'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'

import { PENGELOLAAN_KINERJA_PPK_PENILIK_PATH } from 'app/KinerjaShared/constants/path'

export default function TimPenilaiDaftarPenilikSetujuiSekaligusEmptyState() {
  return (
    <div className="p-9 flex flex-col items-center">
      <div>
        <NextImage
          src={'/illustrations/img-capaian-terbaik.png'}
          alt=""
          height={84}
          width={84}
        />
      </div>
      <div className="mt-3 flex flex-col gap-1 text-center w-[480px]">
        <Text variant="heading-md" as="h2">
          Semua Perencanaan sudah Anda setujui
        </Text>
        <Text color="subdued">
          Terima kasih! Anda dapat cek daftar Perencanaan yang sudah disetujui
          jika diperlukan.
        </Text>
      </div>
      <Link
        passHref
        href={`${PENGELOLAAN_KINERJA_PPK_PENILIK_PATH}/perencanaan/daftar-penilik/disetujui`}
      >
        <Button as="a" className="mt-5" size="lg">
          Cek daftar Perencanaan yang sudah disetujui
        </Button>
      </Link>
    </div>
  )
}
